import { render, staticRenderFns } from "./CreateSender.vue?vue&type=template&id=597af4d6&scoped=true"
import script from "./CreateSender.vue?vue&type=script&lang=js"
export * from "./CreateSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597af4d6",
  null
  
)

export default component.exports